<template>
<div class="w-full h-full">
  <div v-if="card" class="h-screen bg-white w-full">
    <div 
    :class="cardStyle()"
    class="w-full py-10 relative">
    

      <img
        @click="loadContractor()"
        v-if="card.contractor && card.contractor.avatar"
        class="rounded-full h-20 w-20 shadow mx-auto object-cover"
        :src="card.contractor.avatar"
        alt="Profile Image"
      />
      <img
        v-else
        class="rounded-full h-20 w-20 shadow mx-auto object-cover"
        src="data:image/jpeg;base64,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"
        alt="Profile Image"
      />

      <h2
        v-if="card.contractor"
        @click="loadContractor()"
        class="mt-6 text-white header-heavy tracking-tight text-xl"
      >
        {{ card.contractor.name }}
      </h2>

      
      <h2
        v-else
        @click="loadContractor()"
        class="mt-6 text-white header-heavy tracking-tight text-xl"
      >
        No Assigned Contractor
      </h2>

      <div v-if="card.status =='ON-CALL'" @click="updateCard('FIRM')" class="w-1/2 mx-auto rounded p-4 cursor-pointer my-6 bg-primary text-white">
        CONFIRM THIS JOB
      </div>

      <div v-if="card.status == 'FIRM'" class="w-1/2 mx-auto my-6 text-white text-3xl header-bold">
        JOB CONFIRMED
      </div>

      <h2 class="text-white header text-base">
        <svg
          class="w-5 h-5 inline-block text-gray-700"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clip-rule="evenodd"
          ></path>
        </svg>
        {{ card.address.street_number }} {{ card.address.route }}, {{ card.address.locality }}<br />
        {{card.address.postal_code}}, {{card.address.administrative_area_level_1}} {{card.address.country}}
        <a :href="'https://www.google.com/maps?q='+card.address.latitude+','+card.address.longitude" target="_blank" class="text-white underline text-xs cursor-pointer">View Map</a>
      </h2>
    </div>

    <div class="relative h-full -mt-4 bg-gray-200 rounded-t-xl p-2">
      <div
        class="w-full bg-white border-2 border-dashed border-gray-500 rounded-lg text-left p-4"
      >
        <h2
          v-if="card.status == 'confirmed'"
          class="text-xl tracking-tight header-heavy text-gray-900"
        >
          <span class="w-4 h-4 bg-primary rounded-full inline-block"></span> JOB
          CONFIRMED
        </h2>
        <h2
          v-if="card.status == 'unconfirmed'"
          class="text-xl tracking-tight header-heavy text-gray-900"
        >
          <span class="w-4 h-4 bg-yellow-500 rounded-full inline-block"></span>
          JOB UNCONFIRMED
        </h2>
        <h2
          v-if="card.status == 'unscheduled'"
          class="uppercase text-xl tracking-tight header-heavy text-gray-900"
        >
          <span class="w-4 h-4 bg-red-600 rounded-full inline-block"></span> JOB
          Unscheduled
        </h2>


        <h2 class="header-bold text-gray-700 text-lg">Job Details</h2>
        
        <div>
          <span class="header-heavy text-sm">Time</span>
          <span class="ml-2">{{ $moment(new Date(card.date.seconds * 100)).format("DD MMMM @ HH:mmA") }}</span>
        </div>
        <div>
          <span class="header-heavy text-sm">Phone</span>
          <a :href="'tel:'+card.phone" class="text-primary ml-2">{{ card.phone }}</a>
        </div>

        <div>
          <span class="header-heavy text-sm">Meters</span>
          <span class="ml-2">{{ card.meters }} meters</span>
        </div>

        <div>
          <span class="header-heavy text-sm">Mix Code</span>
          <span class="ml-2">STANDARD</span>
        </div>
        <div>
          <span class="header-heavy text-sm">Requirements</span>
          <span class="ml-2">6 Tests</span>
        </div>

        <div class="mt-2 ">
          <span class="header-heavy text-sm">Address</span>
          
          <iframe
  width="100%"
  height="450"
  style="border:0"
  loading="lazy"
  allowfullscreen
  referrerpolicy="no-referrer-when-downgrade"
  :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyAgzzzBwnKAnilSbETwkny6ApTz18jlHr4&q='+card.address.latitude+','+card.address.longitude">
</iframe>

        </div>

        <div class="pt-4 mt-4 border-t border-gray-300">
          <h2 class="header-bold text-gray-700 text-lg mb-3">Customer Details</h2>
        </div>
        <div class="mt-1">
          <span class="header-heavy text-sm">Customer</span>
          <span class="ml-2">{{ card.company }}</span>
        </div>
        <div class="mt-1">
          <span class="header-heavy text-sm">Contact Name</span>
          <span class="ml-2">{{ card.contact }}</span>
        </div>

        <div class="mt-1">
          <span class="header-heavy text-sm">Email</span>
          <span class="ml-2">{{ card.email }}</span>
        </div>

        <div class="mt-1">
          <span class="header-heavy text-sm">Phone</span>
          <span class="ml-2">{{ card.phone }}</span>
        </div>
      </div>

      <div v-if="card.status == 'confirmed'" class="w-full">
        <input type="file" id="actual-btn" class="hidden" />
        <label for="actual-btn">
          <div class="bg-primary text-white rounded m-2 p-4 header-heavy">
            <svg
              class="w-6 h-6 inline-block"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Attach Site Slip
          </div>
        </label>
      </div>

      <div v-if="card.status == 'unconfirmed'" class="w-full">
        <div class="w-full my-2 text-gray-400 text-xs">
          Confirmation sent about 2 hours ago
        </div>
        <div class="w-full my-2 text-gray-400 text-xs">
          Confirmation sent about 1 day ago
        </div>
        <div class="w-full my-2 text-gray-400 text-xs">
          Confirmation sent about 7 days ago
        </div>
        <input type="file" id="actual-btn" class="hidden" />
        <label for="actual-btn">
          <div class="bg-yellow-500 text-white rounded m-2 p-4 header-heavy">
            Send a Confirmation Request
          </div>
        </label>
      </div>

      <div v-if="card.status == 'unscheduled'" class="w-full mt-4">
        <div class="bg-red-600 text-white rounded m-2 p-4 header-heavy">
          MANUALLY ASSIGN A TESTER
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { bus } from "../main";
import {putFire, getFire} from "../firestore/utils"

export default {
    data(){
        return{
            card: ''
        }
    },
  methods: {
    async getCard(){
        try{
        this.card = await getFire({
            collection: "jobs",
            doc: this.$route.params.id
        })
        } catch(e){
            alert("Sorry something went wrong")
            console.log("err", e)
        }
    },
    async updateCard(status){
      const payload = {status: status}

      await putFire({
        collection: 'jobs',
        doc: this.card.id,
        body: payload
      })

      this.card.status = status

    },
    cardStyle(){
      if(this.card.status == 'ON-CALL') return 'bg-secondary'
      if(this.card.status == 'FIRM') return 'bg-primary'
      if(this.card.status == 'CANCELLED') return 'bg-secondary'
    },
    loadContractor() {
      if(this.card.contractor) bus.$emit("loadOwnerCardFunc", this.card.contractor);
    }
  },
  created(){
    this.getCard()
  }
};
</script>
